export default class AnimateHelper {

    /**
     * Construct
     *
     * @param id
     * @param animation
     */
    constructor(id, animation)
    {
        this.id              = id;
        this.animation       = animation;
        this.element         = document.getElementById(id);
        this.transitionEvent = this.whichTransitionEvent();
        this.animationEvent  = this.whichAnimationEvent();
    }

    /**
     * Animate the element then queue to remove the class
     */
    animate()
    {
        if (!this.element) {
            return;
        }

        this.element.classList.add(this.animation);

        // Add a listener to remove the class
        this.element.addEventListener(this.animationEvent, function(animation, elm) {
            elm.target.classList.remove(animation);
        }.bind(this.element, this.animation), false);
    }

    /**
     * Animate the element then queue to remove the class
     */
    transition()
    {
        if (!this.element) {
            return;
        }

        this.element.classList.add(this.animation);

        // Add a listener to remove the class
        this.element.addEventListener(this.transitionEvent, function(animation, elm) {
            elm.target.classList.remove(animation);
        }.bind(this.element, this.animation), {once : true});
    }

    whichAnimationEvent()
    {
        var t,
            el = document.createElement(this.makeid());

        var animations = {
            "animation"       : "animationend",
            "OAnimation"      : "oAnimationEnd",
            "MozAnimation"    : "animationend",
            "WebkitAnimation" : "webkitAnimationEnd"
        };

        for (t in animations) {
            if (el.style[t] !== undefined) {
                return animations[t];
            }
        }
    }

    /**
     * Function from David Walsh: http://davidwalsh.name/css-animation-callback
     *
     * @returns {*}
     */
    whichTransitionEvent()
    {
        var t,
            el = document.createElement(this.makeid());

        var transitions = {
            "transition"       : "transitionend",
            "OTransition"      : "oTransitionEnd",
            "MozTransition"    : "transitionend",
            "WebkitTransition" : "webkitTransitionEnd"
        };

        for (t in transitions) {
            if (el.style[t] !== undefined) {
                return transitions[t];
            }
        }
    }

    makeid()
    {
        var text     = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

        for (var i = 0; i < 12; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return text;
    }
}